import type {Observable} from 'rxjs';
import {bufferCount, filter, map} from 'rxjs/operators';
import {Barcode} from './barcode';

// rxjs pipeable operator for barcode scanning results validation
// based on the buffer size it returns most frequent result
export function validateResults(allowEmpty: boolean, validationBufferSize: number) {

    function countElementOccurrence(barcode: Barcode, barcodes: Barcode[]): number {
        return barcodes.filter((currentBarcode) => Barcode.equals(currentBarcode, barcode)).length;
    }

    function compareByOccurrence(barcode1: Barcode, barcode2: Barcode, barcodes: Barcode[]): number {
        return countElementOccurrence(barcode1, barcodes) - countElementOccurrence(barcode2, barcodes);
    }

    function getMostFrequentOccurrence(barcodes: Barcode[]): Barcode {
        return barcodes.sort((barcode1, barcode2) => compareByOccurrence(barcode1, barcode2, barcodes)).pop();
    }

    return (source: Observable<Barcode>) =>
        source
            .pipe(
                filter((barcode) => !barcode.isEmpty() || allowEmpty),
                bufferCount(validationBufferSize, 1),
                map(getMostFrequentOccurrence)
            );
}